import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=16a8494f&"
import script from "./CreateAccount.vue?vue&type=script&lang=ts&"
export * from "./CreateAccount.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports